import React from 'react';
import { Hidden, Stack, Typography } from '@mui/material';

import _ from 'lodash';

const headerBackground = {
  background: `linear-gradient(to right top, #c4eaff, #d3edff, #e1f0ff, #edf4ff, #f6f8ff, #f6f8ff, #f6f8ff, #f6f8ff, #edf4ff, #e1f0ff, #d3edff, #c4eaff);`,
};

const HeaderSDG = () => {
  return (
    <Stack direction='column' sx={headerBackground} alignItems='center'>
      <Stack
        px={16}
        direction='row'
        alignItems='center'
        justifyContent='center'
        spacing={{ xs: 1, md: 2, lg: 2 }}
        m={{ xs: 1, md: 1, lg: 2 }}
        my={{ xs: 1, md: 1, lg: 2 }}
      >
        <Hidden mdDown>
          <Stack>
            <img alt='domes-header' src='/assets/domes-header.png' width={500} height='auto'></img>
          </Stack>
          {/* <Stack>
            <Typography variant='h4' sx={{ textAlign: 'left', color: '#FFFFFF', fontWeight: 700 }}>
              Indonesia's SDG Best Practices, Stories, and Documents Repository
            </Typography>
          </Stack>
          <Stack>
            <img alt='logo bappenas' src='/repository/assets/bappenas_logo_square.png' width={100} height='auto'></img>
          </Stack>
          <Stack>
            <img alt='logo un indonesia' src='/repository/assets/logo_un_indonesia.png' width={100} height='auto'></img>
          </Stack> */}
        </Hidden>
      </Stack>
      <Hidden mdUp>
        <Stack m={4} direction='column' spacing={1} alignItems='center' justifyContent='center' sx={{ width: '100vw', height: 80 }}>
          <Stack direction='row' spacing={1} alignItems='center'>
            <Stack>
              <img alt='domes-header' src='/assets/domes-header.png' width={350} height='auto'></img>
            </Stack>
          </Stack>
        </Stack>
      </Hidden>
    </Stack>
  );
};

export default HeaderSDG;
